module.exports = __webpack_public_path__ + "static/roy-favicon-881021205ebfdabde4469f1db6170c13.png";